import React from "react";
import { neturalBlack } from "../../../constants/color";
import useAdminTransferList from "../../../Hooks/admin/useAdminTransferList";
import TransferFilterBar from "../../../components/admin/marketplace/TransferFilterBar";
import TransferTable from "../../../components/admin/marketplace/TransferTable";
import TransferPagination from "../../../components/admin/marketplace/TransferPagination";

const TransfersListPage = () => {
  const {
    transfers,
    totalCount,
    hasMore,
    loading,
    error,
    filters,
    currentPage,
    onFilterChange,
    onPageChange,
    onClearFilters,
  } = useAdminTransferList();

  if (error) {
    return (
      <div className="main-div-right-section">
        <div className="second-section-style">
          <div
            style={{
              padding: "20px",
              backgroundColor: "#FDE7E7",
              borderRadius: "12px",
              color: "#EA1010",
              fontSize: "16px",
            }}
          >
            Error loading transfers: {error.message}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-div-right-section">
      <div className="second-section-style">
        {/* Header */}
        <div
          style={{
            marginBottom: "24px",
          }}
        >
          <label
            style={{
              fontSize: "22px",
              fontWeight: "bold",
              color: neturalBlack,
            }}
          >
            All Seller Transfers
          </label>
        </div>

        {/* Filters */}
        <TransferFilterBar
          filters={filters}
          onFilterChange={onFilterChange}
          onClearFilters={onClearFilters}
          totalCount={totalCount}
        />

        {/* Table */}
        <TransferTable transfers={transfers} loading={loading} />

        {/* Pagination */}
        {!loading && totalCount > 0 && (
          <TransferPagination
            currentPage={currentPage}
            totalCount={totalCount}
            pageSize={20}
            hasMore={hasMore}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
};

export default TransfersListPage;
